import { RoleTypes } from '@shared/models/roles.model';
import {
	Actions,
	ActionTypes
}                    from './actions';
import {
	ICurrentUserState,
	initialState
}                    from './state';

export function reducer( state = initialState, action: Actions ): ICurrentUserState {
	switch ( action.type ) {
		// LOGIN
		// case ActionTypes.LOGIN_REQUEST:
		// 	return {
		// 		...state,
		// 		error: null,
		// 		isLoading: true
		// 	};
		case ActionTypes.LOGIN_SUCCESS:
			return {
				...state,
				// @ts-ignore
				isAuthenticated: action?.payload?.isAuthenticated,
				// @ts-ignore
				profile: { ...action?.payload?.profile },
				roles: [ ...action?.payload?.roles ],
				currentUserId: action?.payload?.currentUserId,
				tenantId: action?.payload?.tenantId,
				managedObject: action?.payload?.managedObject,
				error: null,
				isLoading: false
			};
		case ActionTypes.LOGIN_FAILURE:
			return {
				...state,
				isAuthenticated: false,
				profile: null,
				roles: [],
				currentUserId: null,
				error: action?.payload?.error,
				isLoading: false,
				tenantId: null,
				managedObject: null
			};

		// LOGOUT
		case ActionTypes.LOGOUT_REQUEST:
			return {
				...state,
				error: null,
				isLoading: true
			};
		case ActionTypes.LOGOUT_SUCCESS:
			return {
				...state,
				isAuthenticated: false,
				profile: null,
				roles: [],
				error: null,
				currentUserId: null,
				isLoading: false,
				tenantId: null,
				managedObject: null
			};
		case ActionTypes.LOGOUT_FAILURE:
			return {
				...state,
				error: action.error,
				isLoading: false
			};

		// MANAGE TENANT
		case ActionTypes.MANAGE_TENANT_ACTIVE:
			return {
				...state,
				manageTenant: action?.payload
			};

		case ActionTypes.MANAGE_TENANT_INACTIVE:
			return {
				...state,
				manageTenant: null
			};

		// USER
		case ActionTypes.SET_CURRENT_USER:
			return {
				...state,
				user: {
					...action?.payload,
					roles: state?.roles as RoleTypes[]
				}
			};

		default: {
			return state;
		}
	}
}
